import React, { forwardRef } from "react";
import { RCCHookToast, RCCRefModalProps } from "react-common-components";
import { useForm } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import Modal from "../Modal";
import HierarchySWOT from "./HierarchySWOT";
import IModalSWOT from "./interface";

const ModalHierarchySWOT: React.ForwardRefRenderFunction<RCCRefModalProps, IModalSWOT> = ({
	onClose,
	subtitle,
	title,
	onSubmit,
	footer,
	nodeContent,
	selectOptions,
	initialData,
	SWOTId,
	SWOTItemId
}, ref) => {

	const {
		register,
		handleSubmit,
		reset,
		setValue
	}= useForm();

	const { addToast} = RCCHookToast();
	const { translate } = useTranslation();

	const handlerSubmit = async(data:any) => {
		try {
			const correctArray = Object.values(data).filter((x) => typeof x === "string");
			if(onSubmit){
				await onSubmit(correctArray);
			}
		} catch (error) {
			standardErrorMessages(error, translate("Erro ao tratar dados para validação"), addToast);
		}
	};

	return(
		<Modal
			ref={ref}
			header={{
				title: title || translate("Hierarquia de items SWOT"),
				subtitle,
				icon: {
					name:"table"
				}
			}}
			footer={footer || {
				showSaveButton: true,
				buttonLoadingText: translate("Carregando"),
				saveButtonText: translate("Confirmar"),
				cancelButtonText: translate("Cancelar")
			}}
			onSubmit={handleSubmit(handlerSubmit)}
			onClose={() => {
				reset();
				if(onClose !== undefined)
					onClose();
			}}
		>
			{nodeContent && nodeContent}
			<HierarchySWOT
				register={register}
				selectOptions={selectOptions} 
				initialData={initialData}
				SWOTId={SWOTId}
				SWOTItemId={SWOTItemId}
				setValue={setValue}
			/>
		</Modal>
	);};

export default forwardRef(ModalHierarchySWOT);
